import React, { FC } from "react";
import { QrCameraProps } from "../interfaces";
import { QrMask } from "../qrMask/QrMask";
import { makeStyles } from '@mui/styles';
import { useCameraRotate } from "./hooks/useCameraRotate";

const useStyles = makeStyles({
  container: {
    width: 444,
    height: 335,
    position: "relative",
    borderRadius: 15,
    "@media screen and (max-width: 447px)": {
      width: "100vw"
    }
  }
});

export const QrCamera: FC<QrCameraProps> = ({ type, setRef, shouldUpdateStyles }) => {
  const classes = useStyles();
  const { getCameraRotationStyles } = useCameraRotate();

  return (
    <div className={classes.container} style={getCameraRotationStyles()} data-testid="camera-wrapper">
      <video
        height={"100%"}
        width={"100%"}
        ref={ref => {
          setRef(ref!);
        }}
        style={{
          borderRadius: "15px"
        }}
      />
      <QrMask type={type} shouldUpdateStyles={shouldUpdateStyles} />
    </div>
  );
};
